var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsertBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 6.445-.54.516-7.5 7.5-1.265 1.289h18.61l-1.266-1.29-7.5-7.5L12 6.446Zm0 2.133 5.672 5.672H6.328L12 8.578Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertBefore);
export default __webpack_public_path__ + "static/media/insert-before.98244b49c3e4a6bda08ce8e0752aa8d1.svg";
export { ForwardRef as ReactComponent };